'use strict';

var _require = require('prop-types'),
    shape = _require.shape,
    array = _require.array,
    number = _require.number;

module.exports = {
  axs: shape({
    space: array,
    typeScale: array,
    breakpoints: array,
    radius: number
  })
};


//////////////////
// WEBPACK FOOTER
// ./~/axs/dist/context-types.js
// module id = 53
// module chunks = 0